export default __webpack_public_path__ + "static/media/Tools&Supplies.781e3871.png";